import Vue from "vue";
import gaService from "./ga.service";

export default {
    async openSession(options = { lang: "en", gameId }) {
        gaService.send("games", "vegas", options.gameId);
        return (await Vue.http.post("/api/vegas/session/open", Object.assign({}, options))).data;
    },
    async closeSession() {
        return (await Vue.http.post("/api/vegas/session/close")).data;
    }
};


// WEBPACK FOOTER //
// ./_common/services/vegas.service.js